import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff8fc32a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { id: "detail-navigation" }
const _hoisted_4 = { id: "detail=content" }
const _hoisted_5 = {
  class: "detail-content",
  id: "overview"
}
const _hoisted_6 = {
  class: "detail-content",
  id: "portfolio"
}
const _hoisted_7 = {
  class: "detail-content",
  id: "service"
}
const _hoisted_8 = {
  class: "detail-content",
  id: "jadwal"
}

import * as Vue from "vue";
import store from '@/store'
import json from '@/mock.json'
import '@/assets/sass/profil.sass'

import Profile from "@/components/Profile.vue";
import PortfolioList from "@/components/PortfolioList.vue"


import {ref} from "@vue/runtime-core";
import axios from "axios";
import {ProfileResponse} from "@/types/ProfileResponse";
import ServiceList from "@/components/ServiceList.vue";
import Schedule from "@/components/Schedule.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailProfil',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string
}



const content = ref("overview");

function setContent(contentId: string) {
  content.value = contentId
}
function showContent(id: string) {
  return content.value === id
}

const artist = ref(null)

getInfo()

const service = json.service[1]

async function getInfo() {
  await axios.get('/api/profile/info/'+props.id)
      .then(response => {
        artist.value = response.data.results[0]
      })
      .catch(error => console.log(error))
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setContent('overview'))),
          class: _normalizeClass({ pop: showContent('overview') })
        }, " Overview ", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setContent('portfolio'))),
          class: _normalizeClass({ pop: showContent('portfolio') })
        }, " Portfolio ", 2),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setContent('service'))),
          class: _normalizeClass({ pop: showContent('service') })
        }, " Service ", 2),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setContent('jadwal'))),
          class: _normalizeClass({ pop: showContent('jadwal') })
        }, " Schedule ", 2)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          (artist.value != null)
            ? (_openBlock(), _createBlock(Profile, {
                key: 0,
                artist: artist.value,
                editable: false
              }, null, 8, ["artist"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, showContent('overview')]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_6, [
          _createVNode(PortfolioList, {
            editable: false,
            url: '/api/profile/portfolio/'+props.id
          }, null, 8, ["url"])
        ], 512), [
          [_vShow, showContent('portfolio')]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createVNode(ServiceList, {
            editable: false,
            url: '/api/profile/service/'+props.id
          }, null, 8, ["url"])
        ], 512), [
          [_vShow, showContent('service')]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createVNode(Schedule, {
            editable: false,
            url: '/api/profile/schedule/'+props.id
          }, null, 8, ["url"])
        ], 512), [
          [_vShow, showContent('jadwal')]
        ])
      ])
    ])
  ]))
}
}

})